<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="2" fill="#03A9F4"/>
    <g clip-path="url(#clip0)">
      <path d="M16.6666 6.7659C16.212 6.96527 15.7277 7.09742 15.2228 7.16159C15.7423 6.85145 16.1387 6.36409 16.3251 5.77666C15.8408 6.06541 15.3061 6.26937 14.7362 6.38319C14.2763 5.89354 13.6209 5.59027 12.9059 5.59027C11.5187 5.59027 10.4019 6.71624 10.4019 8.09659C10.4019 8.2952 10.4187 8.48617 10.46 8.66798C8.37684 8.56638 6.53357 7.56798 5.29531 6.04708C5.07913 6.42215 4.95232 6.85145 4.95232 7.3136C4.95232 8.18138 5.3992 8.95062 6.06531 9.39597C5.66274 9.38833 5.26781 9.27145 4.93322 9.08735C4.93322 9.09499 4.93322 9.10492 4.93322 9.11485C4.93322 10.3325 5.80177 11.3439 6.94072 11.5769C6.73677 11.6326 6.51447 11.6594 6.28378 11.6594C6.12336 11.6594 5.96142 11.6502 5.80941 11.6166C6.13406 12.6089 7.05531 13.3384 8.15072 13.3621C7.29822 14.029 6.21579 14.4308 5.04399 14.4308C4.8385 14.4308 4.64142 14.4216 4.44434 14.3964C5.55427 15.1121 6.86968 15.5208 8.28822 15.5208C12.8991 15.5208 15.4199 11.7014 15.4199 8.39069C15.4199 8.27992 15.4161 8.17298 15.4107 8.0668C15.908 7.71388 16.3259 7.27312 16.6666 6.7659Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect x="4.44434" y="4.44446" width="12.2222" height="12.2222" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'ShareTW'
}
</script>
